// plugins/jquery.client.ts
import jQuery from 'jquery'

export default defineNuxtPlugin(() => {
  // Expose jQuery globally for plugins like Mapplic
  if (process.client) {
    window.$ = jQuery
    window.jQuery = jQuery
  }

  return {
    provide: {
      $: jQuery,
      jQuery
    }
  }
})



// import jQuery from 'jquery'

// export default defineNuxtPlugin(() => {
//   window.$ = window.jQuery = jQuery
// })

